import React, { Fragment } from 'react';
import { Card, CardBody, Button } from 'reactstrap';
import styled from "styled-components";
import Translate from '../../../helpers/Translate';
const LinkDiv = styled.div`
width: calc(100% + 3px);
margin-left: 50%;
width: 50%;
border: 1px solid white;
border-top-left-radius: 4px;
border-top-right-radius: 4px;
border-bottom-left-radius: 10px;
border-bottom-right-radius: 4px;
.hero-button{
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 4px;
  font-size: 15px;
  text-align: center;
  padding: 5px;
  cursor: pointer;
  background-color: green;
  color:white;
} `;
const ChatLinkItems = ({ linkItems, isTranslate, translateLang }) => {
  const SildeItem = JSON.parse(linkItems.text);
  const handleLink = (e) => {
    e.preventDefault();
    window.open(SildeItem.url);
  };
  return (
    <Fragment>
      <LinkDiv>
        <div className="hero-button"
          onClick={(e) => handleLink(e)}>
          {isTranslate === true ? <Translate input={SildeItem.caption} lang={translateLang}></Translate> :
            SildeItem.caption}</div>
      </LinkDiv>
    </Fragment>

  );
};

export default ChatLinkItems;